export enum SessionRecordingNextRecordType {
  ONCE_WHEN_ACTIVE = 'ONCE_WHEN_ACTIVE',
  ALWAYS_WHEN_ACTIVE = 'ALWAYS_WHEN_ACTIVE',
  N_TIMES_WHEN_ACTIVE ='N_TIMES_WHEN_ACTIVE',
  NO_AUTO_START = 'NO_AUTO_START',
}
